import { render, staticRenderFns } from "./literature.vue?vue&type=template&id=70832561&scoped=true&"
import script from "./literature.vue?vue&type=script&lang=js&"
export * from "./literature.vue?vue&type=script&lang=js&"
import style0 from "./literature.vue?vue&type=style&index=0&id=70832561&lang=scss&scoped=true&"
import style1 from "./literature.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70832561",
  null
  
)

export default component.exports